import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/app.config";
import { ComentariosGerenciados } from "src/app/models/ComentariosGerenciados";
import { ErrorHandlerService } from "../errorHandler.service";
import { firstValueFrom, tap } from "rxjs";
import { StorageService } from "../storage.service";
import { DataControleRepositorio } from "src/app/repositorios/dataControle.repositorio";
import { EnumTipoDataControle } from "src/app/enums/EnumDataControle";

@Injectable()
export class UsuarioComentariosGerenciadosService {
  readonly databaseName = "svdm";
  readonly collectionName = "comentario-gereciado-conteudo";
  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    private storageService: StorageService,
    private dataControleRepositorio: DataControleRepositorio
  ) {}

  public async carregarComentariosGerenciadosPorLei(
    leiId: string
  ): Promise<ComentariosGerenciados> {
    const url = `${AppConfig.apiEndpoint}/Comentarios/ComentariosGerenciados`;
    let requestParams = new HttpParams();
    let comentariosGerenciados: ComentariosGerenciados;
    const comentariolocal = await this.buscarComentarioGerenciadoLoca(leiId);

    if (comentariolocal) {
      const cache = await this.VerificaCacheComentariosGerenciados();

      if (cache) {
        return comentariolocal;
      }
    }

    requestParams = requestParams.append("IdLei", leiId);
    requestParams = requestParams.append(
      "DataUltimaAtualizacao",
      // comentario ? comentario.dataUltimaAtualizacao :
      new Date(0).toISOString()
    );

    await firstValueFrom(
      this.httpClient
        .get<ComentariosGerenciados>(url, { params: requestParams })
        .pipe(
          tap({
            next: (result: ComentariosGerenciados) => {
              if (result) {
                const coment = new ComentariosGerenciados(result);
                this.salvarComentariosGerenciadosLocal(coment).catch(
                  (error) => {
                    this.errorHandlerService.handleError(error);
                  }
                );
                comentariosGerenciados = coment;
                this.dataControleRepositorio
                  .salvar(
                    this.dataControleRepositorio.generateDataControleTipo(
                      EnumTipoDataControle.DataVerificacaoCacheComentariosGerenciados
                    )
                  )
                  .then(() => {})
                  .catch((error) =>
                    this.errorHandlerService.handleError(error)
                  );
              } else {
                comentariosGerenciados = new ComentariosGerenciados();
              }
            },
            error: (error) => {
              this.errorHandlerService.handleError(error);
              if (comentariolocal) {
                comentariosGerenciados = comentariolocal;
              } else {
                comentariosGerenciados = new ComentariosGerenciados();
              }
            },
          })
        )
    );

    return comentariosGerenciados;
  }

  public async salvarComentariosGerenciadosLocal(
    comentario: ComentariosGerenciados
  ): Promise<void> {
    await this.storageService
      .upsert<ComentariosGerenciados>(
        comentario,
        this.databaseName,
        this.collectionName
      )
      .catch((error) => {
        this.errorHandlerService.handleError(error);
      });
  }

  public async buscarComentariosGerenciadosLocal(): Promise<
    ComentariosGerenciados[]
    > {
    return await this.storageService
      .list<ComentariosGerenciados>(this.databaseName, this.collectionName)
      .then((comentarios: ComentariosGerenciados[]) => comentarios)
      .catch((error) => {
        this.errorHandlerService.handleError(error);
        return new Array<ComentariosGerenciados>();
      });
  }

  public async buscarComentarioGerenciadoLoca(
    leiId: string
  ): Promise<ComentariosGerenciados> {
    return await this.storageService
      .getByKey<ComentariosGerenciados>(
        leiId,
        this.databaseName,
        this.collectionName
      )
      .then((comentario: ComentariosGerenciados) => comentario)
      .catch((error) => {
        this.errorHandlerService.handleError(error);
        return new ComentariosGerenciados();
      });
  }

  private async VerificaCacheComentariosGerenciados(): Promise<boolean> {
    const lastDocumentsListCheck = await this.dataControleRepositorio.buscar(
      EnumTipoDataControle.DataVerificacaoCacheComentariosGerenciados
    );
    const tempoEmMinutos = AppConfig.cacheConteudo;

    if (lastDocumentsListCheck) {
      const cacheConteudo: number = tempoEmMinutos * 60 * 1000;
      const ultimaModificacao: Date =
        lastDocumentsListCheck.dataHoraModificacao;
      const DataAtual: Date = new Date();

      if (DataAtual.getTime() - ultimaModificacao.getTime() < cacheConteudo) {
        return true;
      }
    }
    return false;
  }
}
